import React from 'react';
import {useLoading} from "../../../components/context/LoadingContext";
import {deleteObject, listAll, ref} from "firebase/storage";
import {db, eventsCollectionName, eventScheduledBadgesCollectionName, storage} from "../../../components/Firebase/Firebase";
import {collection, deleteDoc, doc, getDocs, query, where} from "firebase/firestore";
import BadgePreview from "../badges/BadgePreview";
import {Button} from "@mui/material";
import {MdEdit} from "react-icons/md";
import {FaRegTrashAlt} from "react-icons/fa";
import { ReactComponent as RouteIcon } from '../../../assets/images/route.svg'
import { IoPersonAddOutline } from "react-icons/io5";
import { MdOutlineTimer } from "react-icons/md";
import '../EventsPage.css'
import {useNavigate} from "react-router-dom";

const EventItem = ({ event, onEventUpdated}) => {
    const [isLoading, setIsLoading] = useLoading();

    const navigate = useNavigate();

    const deleteEventFiles = async (eventId) => {
        const storageRef = ref(storage, `${eventsCollectionName}/${eventId}`);
        try {
            const fileList = await listAll(storageRef);
            if (fileList.items.length === 0) {
                console.log('Папка пуста или не существует');
                return;
            }
            const fileDeletionPromises = fileList.items.map(fileRef => deleteObject(fileRef));
            await Promise.all(fileDeletionPromises);
            console.log(`All files in event/${eventId} deleted successfully.`);
        } catch (error) {
            console.error(`Error deleting files in event/${eventId}: `, error);
        }
    };

    const handleDelete = async () => {
        setIsLoading(true);
        try {
            // Clean up scheduled badges first to prevent race with cloud function
            const badgesQuery = query(
                collection(db, eventScheduledBadgesCollectionName),
                where('eventId', '==', event.id)
            );
            const badgeSnap = await getDocs(badgesQuery);
            await Promise.all(badgeSnap.docs.map(badgeDoc => deleteDoc(badgeDoc.ref)));

            await deleteDoc(doc(db, eventsCollectionName, event.id));
            await deleteEventFiles(event.id);

            console.log('Event item deleted successfully');
            onEventUpdated();
        } catch (error) {
            console.error('Error removing document: ', error);
        }
        setIsLoading(false);
    };

    const handleEdit = () => {
        navigate(`/events/edit/${event.id}`, { state: { event } });
    };

    const handleEditDistances = () => {
        navigate(`/events/${event.id}/distances`, { state: { event } });
    };

    const handleAddAthletes = () => {
        navigate(`/events/addAthletes/${event.id}`, { state: { event } });
    }

    const handleTimingSettings = () => {
        navigate(`/events/${event.id}/timing`, { state: { event } });
    }

    return (
        <tr>
            <td>{event.title}</td>
            <td className='preview'>
                <div style={{ position: 'relative', display: 'inline-block' }}>
                    <img src={event.previewImageUrl} alt={event.title}/>
                    {event.activeBadge && (
                        <div style={{ position: 'absolute', bottom: 4, right: 4 }}>
                            <BadgePreview
                                text={event.activeBadge.text}
                                textColor={event.activeBadge.textColor}
                                backgroundColor={event.activeBadge.backgroundColor}
                            />
                        </div>
                    )}
                </div>
            </td>
            <td className='date'>{new Date(event.startDate).toLocaleDateString()}</td>
            <td className='date'>{new Date(event.finishDate).toLocaleDateString()}</td>
            <td className='actions'>
                <div className='actions d-flex align-items-center'>
                    <Button className='success' color="success" onClick={handleEdit}><MdEdit style={{ color: '#fff' }} /></Button>
                    <Button className='success' color="success" onClick={handleTimingSettings}><MdOutlineTimer style={{ color: '#fff' }} /></Button>
                    <Button className='success' color="success" onClick={handleEditDistances}><RouteIcon /></Button>
                    <Button className='success' color="success" onClick={handleAddAthletes}><IoPersonAddOutline style={{ color: '#fff' }} /></Button>
                    <Button className='error' color="error" onClick={handleDelete}><FaRegTrashAlt /></Button>
                </div>
            </td>
        </tr>
    );
};

export default EventItem;